import api from '@/api/company'
import _ from 'lodash'

let host = null

const state = {
  companyThemeSetting: null,
  domainCompany: {}
}

const actions = {
  getCustomJobDetailPageInfo ({ commit }, params) {
    return api.getCustomJobDetailPageInfo(params)
  },
  getCustomJobListPageInfo ({ commit }, params) {
    return api.getCustomJobListPageInfo(params)
  },
  searchCompanyInfo (context, params) {
    return api.searchCompanyInfo(params)
  },
  getCompanyBaseInfo ({ commit }, { id, params }) {
    return api.getCompanyBaseInfo(id, params)
  },
  getCompanyChildrenTree (context, params) {
    return api.getCompanyChildrenTree(params)
  },
  // 员工管理和公司推荐榜单使用独立的可访问公司树列表。
  getHRAccessibleCompanyTree () {
    return api.getHRAccessibleCompanyTree()
  },
  getCompanyPolicyInfo ({ commit }, { companyId }) {
    return api.getCompanyPolicyInfo(companyId)
  },
  getJobPoster ({ commit }, params) {
    return api.getJobPoster(params)
  },
  updateJobPoster ({ commit }, params) {
    return api.updateJobPoster(params)
  },
  getJobPosterTypeList ({ commit }, params) {
    return api.getJobPosterTypeList(params)
  },
  updateJobPosterStatus ({ commit }, params) {
    return api.updateJobPosterStatus(params)
  },
  getCustomRewardsRuleInfo (context, companyId) {
    return api.getCustomRewardsRuleInfo(companyId)
  },
  getCompanyJobCreatorList (context, companyId) {
    return api.getCompanyJobCreatorList(companyId)
  },
  getTeamMemberList (context, params) {
    return api.getTeamMemberList(params)
  },
  getCompanyHrList (context, params) {
    return api.getCompanyHrList(params)
  },
  getCompanyJobLocationList (context, params) {
    return api.getCompanyJobLocationList(params)
  },
  createCompanyJobLocation (context, data) {
    return api.createCompanyJobLocation(data)
  },
  uploadCompanyJobLocation (context, data) {
    return api.uploadCompanyJobLocation(data)
  },
  updateCompanyJobLocation (context, { jobLocationId, data }) {
    return api.updateCompanyJobLocation(jobLocationId, data)
  },
  getCompanyJobPostingChannelList (context, params) {
    return api.getCompanyJobPostingChannelList(params)
  },
  getCompanyStoreFrontList (context, params) {
    return api.getCompanyStoreFrontList(params)
  },
  getCompanyGroupedJobList (context, params) {
    return api.getCompanyGroupedJobList(params)
  },
  getCompanyJobBoardPointDashboardList (context, params) {
    return api.getCompanyJobBoardPointDashboardList(params)
  },
  getClientJobBoardPointDashboardList (context, params) {
    return api.getClientJobBoardPointDashboardList(params)
  },
  getCompanyJobBoardPointDashboardHistory (context, params) {
    return api.getCompanyJobBoardPointDashboardHistory(params)
  },
  getCompanyJobPostingDetailList (context, params) {
    return api.getCompanyJobPostingDetailList(params)
  },
  getClientCompanyJobPostingDetailList (context, params) {
    return api.getClientCompanyJobPostingDetailList(params)
  },
  getCompanyJobPostingDetailHistory (context, params) {
    return api.getCompanyJobPostingDetailHistory(params)
  },
  transferJobPostingPoints (context, params) {
    return api.transferJobPostingPoints(params)
  },
  rechargeJobPostingPoints (context, params) {
    return api.rechargeJobPostingPoints(params)
  },
  changeJobPostingMaxCount (context, params) {
    return api.changeJobPostingMaxCount(params)
  },
  getCompanyJobList (context, params) {
    return api.getCompanyJobList(params)
  },
  getCompanyJobPostingTaskHistory (context, params) {
    return api.getCompanyJobPostingTaskHistory(params)
  },
  createCompanyJobPostingTask (context, params) {
    return api.createCompanyJobPostingTask(params)
  },
  setJobStatus (context, params) {
    return api.setJobStatus(params)
  },
  setHotJob (context, params) {
    return api.setHotJob(params)
  },
  refreshJob (context, params) {
    return api.refreshJob(params)
  },
  createCompanyAutomationSettings (context, params) {
    return api.createCompanyAutomationSettings(params)
  },
  getCompanyAutomationSettings (context, { companyId }) {
    return api.getCompanyAutomationSettings(companyId)
  },
  getJobListFilterList (context, params) {
    return api.getJobListFilterList(params)
  },
  updateJobListFilterList (context, params) {
    return api.updateJobListFilterList(params)
  },
  getCustomLandingPageInfo (context, { pageNum, params }) {
    return api.getCustomLandingPageInfo(pageNum, params)
  },
  updateCustomLandingPageInfo (context, { pageNum, data }) {
    return api.updateCustomLandingPageInfo(pageNum, data)
  },
  getCompanyLocation (context, params) {
    return api.getCompanyLocation(params)
  },
  getCvOwnerList (context, params) {
    return api.getCvOwnerList(params)
  },
  getJobFilterItemBinding (context, { filterId, params }) {
    return api.getJobFilterItemBinding(filterId, params)
  },
  getJobFilterList (context, params) {
    return api.getJobFilterList(params)
  },
  updateJobFilter (context, { filterId, data }) {
    return api.updateJobFilter(filterId, data)
  },
  saveJobFilter (context, data) {
    return api.saveJobFilter(data)
  },
  moveJobFilter (context, data) {
    return api.moveJobFilter(data)
  },
  updateJobFilterItemBinding (context, { filterId, data }) {
    return api.updateJobFilterItemBinding(filterId, data)
  },
  getCompanyBrandingPageInfo (context, params) {
    return api.getCompanyBrandingPageInfo(params)
  },
  getCompanyCustomJobFilterList (context, { companyId, params }) {
    return api.getCompanyCustomJobFilterList(companyId, params)
  },
  async getCompanyTheme (context, { companyId, params, noUseGlobal = false }) {
    const resp = await api.getCompanyTheme(companyId, params)
    if (_.isEmpty(resp) || noUseGlobal) {
      context.commit('SET_COMPANY_THEME_SETTING', null)
    } else {
      context.commit('SET_COMPANY_THEME_SETTING', resp)
    }
    return resp
  },
  clearCompanyThemeSetting (context) {
    context.commit('SET_COMPANY_THEME_SETTING', null)
  },
  async getDomainCompany (context, params) {
    const currentHost = window.location.host
    if (currentHost === host) {
      return context.state.domainCompany
    }
    host = currentHost
    const resp = await api.getDomainCompany(params)
    if (resp) {
      context.commit('SET_DOMAIN_COMPANY', resp)
    }
    return resp
  },
  clearDomainCompany (context) {
    context.commit('SET_DOMAIN_COMPANY', {})
  },
  registerCompany (context, params) {
    return api.registerCompany(params)
  }
}

const mutations = {
  SET_COMPANY_THEME_SETTING (state, data) {
    state.companyThemeSetting = data
  },
  SET_DOMAIN_COMPANY (state, company) {
    state.domainCompany = company
  }
}

const getters = {
  companyThemeSetting (state) {
    return state.companyThemeSetting
  },
  domainCompany (state) {
    return state.domainCompany
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
